import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useHttpUtility from "../utilities/useHttpUtility";
import useFormUtility from "../utilities/useFormUtility";
import LoadingScreen from "../components/LoadingScreen"
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemSave from "../components/MenuPageItemSave";
import FormFieldText from "../components/FormFieldText";
import FormFieldCheckbox from "../components/FormFieldCheckbox";
import FormFieldSelect from "../components/FormFieldSelect";

export default function PageSettingsDelivery() {

    const navigate = useNavigate();
    const http = useHttpUtility();

    const formUtility = useFormUtility(null);

    const bookModes = [
        { "name": "Shopify Webhook", "value": 1 },
        { "name": "Shopify Order Page", "value": 2 }
    ];

    const autoFulfillModes = [
        { "name": "Disabled", "value": 0 },
        { "name": "On Delivered", "value": 1 },
        { "name": "On Pickup", "value": 2 },
        { "name": "On Label Printed", "value": 3 }
    ];

    useEffect(() => {
        http.get(
            "/api/Settings/Delivery",
            (d) => formUtility.setData({ ...d, bookMode: d.bookMode.toString(), autoFulfillMode: d.autoFulfillMode.toString() }));
    }, []);

    return (
        !formUtility.data
            ? <LoadingScreen />
            :
            <div className="page page-settings-delivery">
                <MenuPage>
                    <MenuPageItemDiscard formUtility={formUtility} onClick={() => navigate(`..${window.location.search}`)} />
                    <MenuPageItemSave formUtility={formUtility} onClick={() => http.post("/api/Settings/Delivery", formUtility.data)} />
                </MenuPage>
                <FormFieldSelect formUtility={formUtility} options={bookModes} field="bookMode" label="Book Mode" description="If your site has subscriptions or you import orders into Shopify via a spreadsheet or service then use Shopify Order Page mode." />
                <FormFieldSelect formUtility={formUtility} options={autoFulfillModes} field="autoFulfillMode" label="Auto Fulfill Mode" description="Only available for orders with Urgent Couriers." />
                <FormFieldText formUtility={formUtility} field="deliveryInstructionAttributes" label="Delivery Instruction Attributes (Optional)" />
                <FormFieldCheckbox formUtility={formUtility} field="bookTagsAddDate" label="Tag orders with date and time" description= "Tag orders with window start date and time, only available for orders with Urgent Couriers." />
                <FormFieldText formUtility={formUtility} field="clientReferenceA" label="Client Reference A (Optional)" description="If left blank, the field will default to Shopify's order ID.  Only available for orders with Urgent Couriers." />
                <FormFieldText formUtility={formUtility} field="clientReferenceB" label="Client Reference B (Optional)" description="If left blank, the field will default to Shopify's fulfillment order ID.  Only available for orders with Urgent Couriers." />
                <FormFieldText formUtility={formUtility} field="ourReference" label="Our Reference (Optional)" description="If left blank, the field will default to Shopify's order number.  Only available for orders with Urgent Couriers." />
                <FormFieldCheckbox formUtility={formUtility} field="signatureRequired" label="Signature Required" description="Only available for orders with Urgent Couriers." />
                <FormFieldCheckbox formUtility={formUtility} field="includeTax" label="Include Tax (Urgent Couriers auto pricing only)" description="Include tax for Urgent Couriers auto pricing.  This option is used when your Shopify settings is set to include tax in prices." />
            </div>
    );
}